import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import moment from "moment";
import { useIntl } from "react-intl";
import { FacebookFormContactResponse } from "../../../cores/facebookForm/interfaces/api/get-facebook-form-contact-response";
import {
  getFacebookFieldLabel,
  getVisibleFacebookFormFields,
} from "../forms/facebook/questionLabels";

interface Props {
  responses: FacebookFormContactResponse[];
}

export default function FacebookFormLeadFields({ responses }: Props) {
  const intl = useIntl();

  if (!responses.length) return null;

  return (
    <div className="mb-4">
      {responses.map((response) => {
        const visibleFields = getVisibleFacebookFormFields(response.fields);
        if (!visibleFields.length) return null;

        return (
          <div
            key={`${response.formId}-${response.id}`}
            className="border rounded-lg p-3 mb-3 facebook-form-lead-fields"
          >
            <div className="d-flex align-items-center mb-3">
              <FontAwesomeIcon
                icon={["fab", "facebook"]}
                className="mr-2"
                style={{ color: "#1877f2" }}
              />
              <div>
                <p className="font-weight-bold mb-0">
                  {intl.formatMessage({ id: "app.contacts.facebookFormData" })}
                </p>
                <p className="text-muted small mb-0">{response.formName}</p>
              </div>
              {response.createdAt ? (
                <p className="text-muted small mb-0 ml-auto">
                  {moment(response.createdAt).format("DD/MM/YYYY HH:mm")}
                </p>
              ) : null}
            </div>

            <div className="row">
              {visibleFields.map((field) => (
                <div className="col-12 col-md-6 mb-3" key={field.name}>
                  <p className="text-muted small text-uppercase mb-1">
                    {getFacebookFieldLabel(field.name, response.questionKeys)}
                  </p>
                  <p className="mb-0 font-weight-bold text-break">
                    {field.name.toLowerCase() === "website" ? (
                      <a
                        href={
                          field.value.startsWith("http")
                            ? field.value
                            : `https://${field.value}`
                        }
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {field.value}
                      </a>
                    ) : (
                      field.value
                    )}
                  </p>
                </div>
              ))}
            </div>
          </div>
        );
      })}
    </div>
  );
}
